import { Controller, Payload } from "../../config/controller";
import store, { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { Medico, initialValueMedicoState, MedicoState, MedicoActions } from "./medico.model"


export interface MedicoViewProps {
    medicoState: MedicoState
    medicoActions: MedicoActions
}


class MedicoController extends Controller<Medico, MedicoState, MedicoActions> {
    constructor() {
        super(initialValueMedicoState.row.type, initialValueMedicoState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects

        ]
    }



    private * medicoReadAllEffects(actions: Payload) {

    }
}

export const medicoController = new MedicoController()

export const mapStateToMedicoProps = (state: ApplicationState) => ({
    medicoState: state.medicoState,
})

export const mapDispatchToMedicoProps = (dispatch: Dispatch) => ({
    medicoActions: bindActionCreators({ ...medicoController.reducer.actions }, dispatch),
})

